import React, { useEffect, useState } from 'react';
import usePagination from '../../common/table/Pagination';
import {
  Box,
  Button,
  ButtonGroup,
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Stack,
  styled,
  Typography
} from '@mui/material';
import { DatePicker, Table } from 'antd';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Search from '../../common/search';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTER_NAME } from '../../router/routers';
import { connect, useDispatch, useSelector } from 'react-redux';
import { formatDate, getSessionFilter, setSessionFilter } from '../../utils/CommonFunction';
import {
  filterQuoteStatus,
  filterQuoteStatusColor,
  getValueFromObjectByKeys,
  handleStatus,
  translate,
  filterQuoteStatusBackground
} from '../../helper';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import { Colors } from '../../themes/Colors';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { fetchOrderListApiCall } from './Action';
import CheckIcon from '@mui/icons-material/Check';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableChartIcon from '@mui/icons-material/TableChart';
import ArticleIcon from '@mui/icons-material/Article';
import Utils from '../../utils';
import ReconnectingWebSocket from 'reconnecting-websocket';
import { UserAction } from '../../redux/action';
import TextBase from '../../common/text';
import { successOrderListReducer } from './Slice/orderListSlice';
import { exportFile } from '../../utils/exportFile';
import ExportButton from '../../common/export-button';
import { useFixedAttributeDisplayNames } from '../../hooks/useFixedAttributeDisplayNames';
import dayjs from 'dayjs';
import CustomSpinner from '../../common/CustomSpinner';
import FilterListIcon from '@mui/icons-material/FilterList';
import PageTitleHeader from '../../common/page-title-header';

const dateTimeFormat = 'MM/DD/YYYY';
const dateTimeFormatServer = 'YYYY-MM-DD';
const PageBox = styled('div')(({ theme }) => ({
  backgroundColor: '#ffffff',
  backgroundImage: 'linear-gradient(135deg, #f5f7fa 0%, #f9fafb 100%)',
  overflowY: 'auto',
  padding: 'calc(var(--sp-lg)*1.5) calc(var(--sp-lg)*1.6) calc(var(--sp-md2)*1)',
  '& .ant-table-container': {
    overflowX: 'auto',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    },
    '@media (max-width: 1200px)': {
      overflowX: 'auto'
    }
  },
  '& .ant-table': {
    backgroundColor: '#ffffff',
    borderRadius: 'calc(var(--sp-md2)*1.50943)',
    overflow: 'hidden',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    border: '1px solid rgba(229, 231, 235, 0.6)',
    borderCollapse: 'collapse',
    '&:hover': {
      boxShadow: '0 12px 48px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04)'
    }
  },
  '& .ant-table-thead > tr': {
    backgroundColor: 'linear-gradient(135deg, #1A5A78 0%, #0F3D52 100%)',
    borderRight: 'none !important',
    borderLeft: 'none !important',
    borderTop: 'none !important'
  },
  '& .ant-table-thead > tr > th': {
    backgroundColor: '#1A5A78 !important',
    color: '#ffffff !important',
    borderBottom: '2px solid #0F3D52 !important',
    borderRight: 'none !important',
    borderLeft: 'none !important',
    borderTop: 'none !important',
    transition: 'all 0.3s ease',
    letterSpacing: '0.035em',
    boxShadow: 'inset 0 1px 2px rgba(255, 255, 255, 0.3), inset 0 -1px 0 rgba(0, 0, 0, 0.1)'
  },
  '& .ant-table-tbody > tr': {
    position: 'relative',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    borderBottom: '1px solid rgba(229, 231, 235, 0.7) !important',
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor:
        'linear-gradient(90deg, rgba(26, 90, 120, 0.06) 0%, rgba(26, 90, 120, 0.02) 100%) !important',
      boxShadow: `
      0 12px 28px rgba(15, 23, 42, 0.10),
      0 2px 8px rgba(15, 23, 42, 0.06)
    `,
      zIndex: 2,

      background:
        'linear-gradient(90deg, rgba(26,90,120,0.04) 0%, rgba(255,255,255,1) 50%, rgba(26,90,120,0.04) 100%)',
      transform: 'translateY(-2px) scale(1.004)'
    },
    '&:last-child': {
      borderBottom: 'none !important'
    }
  },
  '& .ant-table tbody tr': {
    border: 'none !important'
  },
  '& .ant-table-tbody > tr > td': {
    color: '#1f2937',
    transition: 'all 0.2s ease',
    borderBottom: '1px solid rgba(229, 231, 235, 0.8) !important',
    borderRight: 'none !important',
    borderLeft: 'none !important',
    borderTop: 'none !important',
    backgroundColor: '#ffffff'
  },
  '& .ant-table-tbody > tr:last-child > td': {
    borderBottom: 'none !important'
  },
  '& .ant-table-tbody > tr:hover > td': {
    backgroundColor: 'rgba(26, 90, 120, 0.03) !important',
    borderTop: '1px solid rgba(26,90,120,0.08)',
    borderBottom: '1px solid rgba(26,90,120,0.08)'
  },
  '& .MuiOutlinedInput-input': {
    padding: 'var(--sp-md2) calc(var(--sp-md2)*1.4)'
  },
  '& .MuiButton-root': {
    backgroundColor: '#ffffff !important',
    color: '#374151 !important',
    border: '1.5px solid #e5e7eb !important',
    borderRadius: 'var(--sp-md2)',
    fontWeight: '500',
    transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.04)',
    fontSize: 'calc(var(--fs-xs) * 1.5)',
    '&:hover': {
      backgroundColor: '#f9fafb !important',
      borderColor: '#d1d5db !important',
      boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)',
      transform: 'translateY(-2px)'
    },
    '&:active': {
      transform: 'translateY(0)'
    }
  },
  '& .MuiButtonGroup-root': {
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.04) !important',
    height: 'calc(var(--fs-xl)*2.35)',
    borderRadius: 'var(--sp-md2)',
    border: '1.5px solid #e5e7eb !important',
    backgroundColor: '#ffffff',
    transition: 'all 0.2s ease'
  },
  '& .checked': {
    background: 'white',
    borderRadius: 'calc(var(--sp-lg)*2.5)',
    padding: 'calc(var(--sp-xs)*1)',
    fontSize: 'calc(var(--fs-xl)*1.5)',
    color: 'green',
    transition: 'all 0.2s ease'
  },
  '& .unchecked': {
    background: 'white',
    borderRadius: 'calc(var(--sp-lg)*2.5)',
    padding: 'calc(var(--sp-xs)*1)',
    fontSize: 'calc(var(--fs-xl)*1.6)',
    color: '#d1d5db',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: '#9ca3af',
      background: '#e5e7eb'
    }
  }
}));

const ActionButton = styled(Button)(({}) => ({
  background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)',
  color: '#1f2937 !important',
  textTransform: 'capitalize',
  fontWeight: '600 !important',
  padding: 'calc(var(--sp-sm)*1.1) calc(var(--sp-md2)*1.5)',
  borderRadius: 'var(--sp-md2)',
  border: '1.5px solid #d1d5db !important',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  fontSize: 'calc(var(--fs-xs) * 1.6)',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.5)',
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
    transition: 'left 0.5s ease'
  },
  '&:hover': {
    background: 'linear-gradient(135deg, #e5e7eb 0%, #d1d5db 100%)',
    boxShadow: '0 16px 32px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.6)',
    transform: 'translateY(-3px)',
    borderColor: '#9ca3af !important',
    '&::before': {
      left: '100%'
    }
  },
  '&:active': {
    transform: 'translateY(-1px)',
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)'
  },
  '& .icon': {
    fontSize: 'calc(var(--fs-sm2) * 1.1)',
    color: '#6b7280',
    marginLeft: 'calc(var(--sp-md2)*1)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    fontWeight: '700'
  },
  '&:hover .icon': {
    transform: 'translateX(3px)',
    color: '#1f2937'
  }
}));

let socket = null;

const OrderPage = (props) => {
  const SortByOption = [
    { label: translate('newestToOldest'), value: '-created_at' },
    { label: translate('oldestToNewest'), value: 'created_at' }
  ];

  const PaymentFilterOptions = [
    { label: 'All Order', value: 'all_order' },
    { label: 'Stripe', value: 'stripe' },
    { label: translate('accountBilling'), value: 'account' }
  ];

  const ExportOptions = [
    {
      label: 'CSV',
      value: 'csv',
      icon: <ArticleIcon sx={{ fontSize: 'calc(var(--fs-xs) * 1.698113)' }} />
    },
    {
      label: 'Excel',
      value: 'excel',
      icon: <TableChartIcon sx={{ fontSize: 'calc(var(--fs-xs) * 1.698113)' }} />
    },
    {
      label: 'PDF',
      value: 'pdf',
      icon: <PictureAsPdfIcon sx={{ fontSize: 'calc(var(--fs-xs) * 1.698113)' }} />
    }
  ];
  const {
    userInfo: { user, token }
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data, loading, total } = useSelector((props) => props.orderList_vendor);
  const isUserServiceWriter = user?.role === 'SW';
  const isUserTeamMember = props?.userInfo?.profile?.team_member;
  const storageKey = props?.sw ? 'service' : 'orders';
  const prevStorageKeyRef = React.useRef(storageKey);
  const { fixedAttributeDisplayNames } = useFixedAttributeDisplayNames();

  const initialFilters = React.useMemo(() => {
    const stored = getSessionFilter(storageKey, null);
    const today = dayjs();
    const twoWeekAgo = dayjs().subtract(30, 'day');
    const defaultStart =
      stored?.start_at && stored?.start_at !== ''
        ? stored.start_at
        : twoWeekAgo.format(dateTimeFormatServer);
    const defaultEnd =
      stored?.end_at && stored?.end_at !== '' ? stored.end_at : today.format(dateTimeFormatServer);
    return {
      pageNo: stored?.pageNo || 1,
      limit: stored?.limit || 15,
      searchKey: stored?.searchKey || '',
      ordering: stored?.ordering || '-created_at',
      start_at: defaultStart,
      end_at: defaultEnd,
      payment_method: stored?.payment_method || 'all_order' // NEW
    };
  }, [storageKey]);

  const defaultFilters = React.useMemo(
    () => ({
      ...initialFilters
    }),
    [initialFilters]
  );
  const [filters, setFilters] = React.useState(defaultFilters);
  const location = useLocation();
  const [openSortByMenu, setOpenSortByMenu] = React.useState(false);
  const [exportBtnLoading, setExportBtnLoading] = useState(false);
  const anchorRef = React.useRef(null);
  const [openPaymentFilter, setOpenPaymentFilter] = useState(false);
  const [paymentAnchorEl, setPaymentAnchorEl] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); // Checkbox selection

  const [paging] = usePagination(total, filters, setFilters, loading);

  // Handle row selection changes
  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // Row selection configuration with all options
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  };
  const handleDateRangeChange = (dates) => {
    if (dates) {
      let [startDate, endDate] = dates;
      let updatedstartDate = dayjs(startDate).format(dateTimeFormatServer);
      let updatedendDate = dayjs(endDate).format(dateTimeFormatServer);
      setFilters({
        ...filters,
        start_at: updatedstartDate,
        end_at: updatedendDate
      });
    } else {
      setFilters({
        ...filters,
        start_at: '',
        end_at: ''
      });
    }
  };

  const handleExportSelect = (format) => {
    const vendorId = user?.vendor?.id;
    const params = {
      ordering: filters.ordering,
      vendors__id: vendorId,
      page: filters.pageNo,
      page_size: filters.limit,
      search: filters.searchKey,
      start_at: filters.start_at,
      end_at: filters.end_at,
      ...(props?.sw ? { sw: true } : {})
    };
    // Add selected order IDs if any are selected
    if (selectedRowKeys.length > 0) {
      params.order_ids = selectedRowKeys;
    }
    if (filters.payment_method === 'stripe') params.payment_method = '1';
    if (filters.payment_method === 'account') params.payment_method = '2';
    Object.keys(params).forEach(
      (key) => (params[key] == null || params[key] === '') && delete params[key]
    );
    exportFile({
      endpoint: Utils.EndPoint.vendorEndpoints.orderExportApi,
      params,
      format,
      filenameBase: 'orders',
      setLoading: setExportBtnLoading
    });
  };
  React.useEffect(() => {
    const storageKeyChanged = prevStorageKeyRef.current !== storageKey;

    const same =
      filters.pageNo === defaultFilters.pageNo &&
      filters.limit === defaultFilters.limit &&
      filters.searchKey === defaultFilters.searchKey &&
      filters.ordering === defaultFilters.ordering &&
      filters.start_at === defaultFilters.start_at &&
      filters.end_at === defaultFilters.end_at &&
      filters.payment_method === defaultFilters.payment_method;

    if (storageKeyChanged) {
      setFilters({ ...defaultFilters });
      prevStorageKeyRef.current = storageKey;
      return;
    }

    if (!same) setFilters({ ...defaultFilters });
  }, [props?.sw, location?.pathname, defaultFilters, storageKey]);

  React.useEffect(() => {
    if (user?.vendor?.id) {
      setSessionFilter(storageKey, filters);
      fetchOrderListApiCall(
        {
          vendors__id: user?.vendor?.id,
          ...filters
        },
        dispatch,
        [],
        props?.sw
      );
    }
  }, [user, filters]);

  useEffect(() => {
    getUpdates();
    document.title = props?.sw ? 'Service Orders' : 'Order';
    return () => {
      if (socket) {
        socket.close();
      }
    };
  }, []);

  useEffect(() => {
    if (socket) {
      socket.onmessage = (event) => {
        if (window.location.pathname === '/order') {
          let newOrder = JSON.parse(event?.data)?.order || {};
          new CreateNewOrderList(newOrder);
        }
      };
    }
  }, [data]);

  function CreateNewOrderList(order) {
    let exists = false;

    let updatedData = data.map((item) => {
      if (item.id === order.order_id) {
        exists = true;
        return { ...item, ...order };
      }
      return item;
    });

    if (exists) {
      dispatch(
        successOrderListReducer({
          data: updatedData,
          total,
          loading: false
        })
      );
      return;
    }

    const newTotal = total + 1;

    if (filters.pageNo === 1) {
      updatedData = [{ id: order.order_id, ...order }, ...updatedData].slice(0, filters.limit);
    }

    dispatch(
      successOrderListReducer({
        data: updatedData,
        total: newTotal,
        loading: false
      })
    );
  }

  const getUpdates = () => {
    socket = new ReconnectingWebSocket(
      `wss://${Utils.constants.API_URL.replace('https://', '')}ws/orders/?token=${token}`
    );

    socket.addEventListener('open', () => {});
  };
  const handleMenuItemClick = (val) => {
    setFilters({
      ...filters,
      pageNo: 1,
      limit: 10,
      ordering: val
    });
    setOpenSortByMenu(false);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenSortByMenu(false);
  };

  const handlePaymentFilterSelect = (val) => {
    setFilters({ ...filters, pageNo: 1, payment_method: val });
    setOpenPaymentFilter(false);
  };

  const handleFullfilledBy = (row) => {
    const quote = row.quotes?.filter(
      (q) => q.status === 'ACCEPTED' || q.status === 'CUSTOMER ACCEPTED'
    );
    const pending = row.quotes?.find((q) => q.status === 'SENT');
    return quote?.length > 0 ? quote?.[0]?.user?.name : pending?.id ? pending?.user?.name : 'N/A';
  };
  const orderColumns = [
    {
      title: (
        <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>{translate('dateCreated')}</span>
      ),
      dataIndex: 'created_at',
      align: 'left',
      key: 'created_at',
      render: (__, row) => {
        return (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.6)' }}>
            {formatDate(row?.created_at) || ''}
          </span>
        );
      }
    },
    {
      title: (
        <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>{translate('customerPo')}</span>
      ),
      dataIndex: 'id',
      align: 'left',
      key: 'id',
      render: (__, row) => {
        return (
          <Typography
            color={'rgb(81, 125, 152)'}
            fontSize={'calc(var(--fs-xs) * 1.6)'}
            sx={{
              cursor: 'pointer',
              textDecorationLine: 'underline'
            }}
            onClick={(e) => {
              e.stopPropagation();
              navigate(`${ROUTER_NAME.orderDetail}/${row.id}`);
            }}>
            {row.id}
          </Typography>
        );
      }
    },
    {
      title: (
        <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>
          {fixedAttributeDisplayNames?.['order_name'] || translate('orderName')}
        </span>
      ),
      dataIndex: 'name',
      align: 'left',
      key: 'name',
      render: (__, row) => {
        return <span style={{ fontSize: 'calc(var(--fs-xs) * 1.6)' }}>{row.name || ''}</span>;
      }
    },
    {
      title: <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>{translate('status')}</span>,
      dataIndex: 'status',
      align: 'left',
      key: 'status',
      render: (__, row) => {
        const statusLabel = handleStatus(row, isUserServiceWriter, isUserTeamMember);
        const statusColor = filterQuoteStatusColor(statusLabel, isUserServiceWriter);
        const statusBackground = filterQuoteStatusBackground(statusLabel, isUserServiceWriter);
        const status = filterQuoteStatus(statusLabel, isUserServiceWriter, isUserTeamMember);

        const deliverLabelMap = {
          instore: translate('acceptedInStorePickup'),
          delivery: translate('acceptedDelivery')
        };
        return (
          <>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                borderRadius: '6px',
                fontSize: 'calc(var(--fs-xs) * 1.6)',
                fontWeight: 500,
                letterSpacing: '0.01em',
                color: statusColor,
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                whiteSpace: 'nowrap',
                textTransform: 'capitalize',
                cursor: 'default'
              }}>
              {status}
            </Box>
            {row?.status === 'INPROGRESS' && row?.quotes?.length === 0 && (
              <Typography
                variant="p"
                fontWeight={'400'}
                color={'#000'}
                sx={{ fontSize: 'calc(var(--fs-xs) * 1.6)', display: 'block', marginTop: '4px' }}>
                {` - ${row?.order_vendor_note_user_name?.trim()}`}
              </Typography>
            )}
            {status === 'Paid' && (
              <Typography
                variant="p"
                fontWeight={'400'}
                color={'#000'}
                sx={{ fontSize: 'calc(var(--fs-xs) * 1.6)' }}>
                {` - ${deliverLabelMap[row?.delivery_method]}`}
              </Typography>
            )}
            {status === 'Service Accepted' && (
              <Typography
                display={'block'}
                variant="p"
                fontWeight={'400'}
                color={'#000'}
                sx={{ fontSize: 'calc(var(--fs-xs) * 1.6)', marginTop: '4px' }}>
                {deliverLabelMap[row?.delivery_method]}
              </Typography>
            )}
          </>
        );
      }
    },
    {
      title: <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>{translate('core')}</span>,
      dataIndex: 'core',
      align: 'left',
      key: 'core',
      render: (__, row) => {
        return row?.core ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}>
            <CheckBoxIcon className="checked" />
          </div>
        ) : (
          <CheckBoxOutlineBlankIcon className="unchecked" />
        );
      }
    },
    {
      title: (
        <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>
          {translate('warrantyStatus')}
        </span>
      ),
      dataIndex: 'status',
      align: 'left',
      key: 'status',
      render: (__, row) => {
        return row?.warranty ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center'
            }}>
            <CheckBoxIcon className="checked" />
            <span style={{ marginLeft: 'var(--sp-xxs)', fontSize: 'calc(var(--fs-xs) * 1.6)' }}>
              {' '}
              {row.warranty_user_name}
            </span>
          </div>
        ) : (
          <CheckBoxOutlineBlankIcon className="unchecked" />
        );
      }
    },
    {
      title: (
        <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>{translate('fulfilledBy')}</span>
      ),
      dataIndex: 'email',
      align: 'left',
      key: 'email',
      render: (__, row) => {
        return (
          <span style={{ fontSize: 'calc(var(--fs-xs) * 1.6)' }}>
            {handleFullfilledBy(row) || 'N/A'}
          </span>
        );
      }
    },
    {
      title: (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <span
            style={{
              fontSize: 'calc(var(--fs-sm2) * 1.015)',
              color: filters.payment_method !== 'all_order' ? '#FBBF24' : '#ffffff',
              fontWeight: filters.payment_method !== 'all_order' ? 700 : 600,
              transition: 'all 0.2s ease'
            }}>
            {translate('paymentInfo')}
          </span>
          <IconButton
            size="small"
            title="Filter by payment method"
            aria-label="Filter by payment method"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();

              const r = e.currentTarget.getBoundingClientRect();

              const virtualAnchor = {
                getBoundingClientRect: () => ({
                  width: 0,
                  height: 0,
                  x: r.left + r.width / 2,
                  y: r.bottom + 4,
                  top: r.bottom + 4,
                  left: r.left + r.width / 2,
                  right: r.left + r.width / 2,
                  bottom: r.bottom + 4
                })
              };

              setPaymentAnchorEl(virtualAnchor);
              setOpenPaymentFilter((p) => !p);
            }}
            sx={{
              p: 'calc(var(--sp-xxs)*.471698)',
              position: 'relative',
              borderRadius: '999px',
              backgroundColor:
                filters.payment_method !== 'all_order' ? 'rgba(251, 191, 36, 0.18)' : 'transparent',

              '&:hover': {
                backgroundColor:
                  filters.payment_method !== 'all_order'
                    ? 'rgba(251, 191, 36, 0.25)'
                    : 'rgba(255,255,255,0.12)'
              }
            }}>
            <FilterListIcon
              sx={{
                fontSize: 'calc(var(--fs-xs) * 1.698113)',
                color: filters.payment_method !== 'all_order' ? '#FBBF24' : '#ffffff',
                transition: 'all 0.2s ease'
              }}
            />
            {filters.payment_method !== 'all_order' && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 2,
                  right: 2,
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  backgroundColor: '#FBBF24',
                  boxShadow: '0 0 0 2px #0B5C7A'
                }}
              />
            )}
          </IconButton>
        </Box>
      ),
      dataIndex: 'paymentInfo',
      align: 'left',
      key: 'paymentInfo',
      render: (__, row) => {
        if (!(row?.quotes?.[0] && row?.quotes?.[0]?.status === 'ACCEPTED')) {
          return <span style={{ fontSize: 'calc(var(--fs-xs) * 1.6)' }}></span>;
        }

        const isStripe = row?.quotes?.[0]?.stripe_charge_id !== 'NS';
        const label = isStripe ? translate('stripe') : translate('accountBilling');

        return (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              letterSpacing: 'calc(var(--sp-xxs)*0.0943396))',
              color: isStripe ? '#1E40AF' : '#6B21A8',
              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              backdropFilter: 'blur(2px)',
              cursor: 'default'
            }}>
            <Typography
              component="span"
              sx={{
                fontSize: 'calc(var(--fs-xs) * 1.6)',
                color: 'inherit',
                whiteSpace: 'nowrap',
                letterSpacing: 'calc(var(--sp-xxs)*0.0943396))'
              }}>
              {label}
            </Typography>
          </Box>
        );
      }
    },
    {
      title: (
        <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>{translate('orderInfo')}</span>
      ),
      dataIndex: 'orderInfo',
      align: 'left',
      key: 'orderInfo',
      render: (__, row) => {
        return (
          <ActionButton onClick={() => {}}>
            <span style={{ fontSize: 'calc(var(--fs-sm2) * 1.015)' }}>{translate('details')}</span>
            <ArrowForwardIosIcon className="icon" />
          </ActionButton>
        );
      }
    }
  ];

  return (
    <PageBox>
      <PageTitleHeader
        title={props?.sw ? translate('serviceOrders') : translate('orders')}
      />
      <Stack
        style={{ padding: 'var(--sp-lg) 0' }}
        alignItems={'center'}
        justifyContent={'space-between'}
        direction="row"
        spacing={'calc(var(--sp-md2)*1.6)'}>
        <Box>
          <Search
            key={props?.sw ? 'service' : 'order'}
            placeholder={
              (props?.sw ? translate('searchServiceOrders') : translate('searchOrders'))
            }
            tooltip="Search by PO#, order name, fulfilled by, or customer/dealer email."
            setQuery={(value) => {
              setFilters({
                ...filters,
                pageNo: 1,
                searchKey: value
              });
            }}
            value={filters.searchKey}
            sx={{
              width: 'calc(var(--fs-hero)*8.254)',
              '& .MuiOutlinedInput-input': {
                fontSize: 'var(--fs-md2) !important',
                padding: 'var(--sp-md2) var(--sp-md2*1.4)'
              },

              '& .MuiOutlinedInput-input::placeholder': {
                fontSize: 'var(--fs-md2)',
                padding: 'var(--sp-md2) var(--sp-md2*1.4)',
                lineHeight: '100%'
              }
            }}
          />
        </Box>
        <Box className="flex-row-center" gap={'calc(var(--sp-md2)*1.6)'}>
          <DatePicker.RangePicker
            popupClassName="responsive-datepicker-dropdown"
            allowClear={false}
            style={{
              width: 'calc(var(--fs-hero)*6.132075)',
              height: 'calc(var(--fs-xl)*2.35) !important',
              borderRadius: 'calc(var(--sp-xxs)*2)',
              padding: 'calc(var(--sp-md)*1) calc(var(--sp-md)*1)'
            }}
            format={dateTimeFormat}
            for
            disabledDate={(current) => {
              return false;
            }}
            value={[
              filters.start_at ? dayjs(filters.start_at) : null,
              filters.end_at ? dayjs(filters.end_at) : null
            ]}
            defaultValue={undefined}
            onChange={handleDateRangeChange}
            onOk={(value) => {}}
          />
          <ExportButton
            options={ExportOptions}
            onExport={handleExportSelect}
            loading={exportBtnLoading}
          />
          <Button
            ref={anchorRef}
            onClick={() => setOpenSortByMenu((prevOpen) => !prevOpen)}
            sx={{
              textTransform: 'capitalize',
              fontWeight: 700,
              height: 'calc(var(--fs-xl)*2.35) !important',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              borderRadius: 'var(--sp-md2)',
              fontSize: 'calc(var(--fs-sm2) * 1.015)',
              backgroundColor: '#ffffff !important',
              border: '1.5px solid #e5e7eb !important',
              color: '#374151 !important',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.5)',
              transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              padding: 'calc(var(--sp-md)*1) calc(var(--sp-md2)*1.3)',
              display: 'flex',
              alignItems: 'center',
              gap: 'calc(var(--sp-xxs)*1.5)',
              '&:hover': {
                backgroundColor: '#f3f4f6 !important',
                borderColor: '#d1d5db !important',
                boxShadow:
                  '0 12px 24px rgba(0, 0, 0, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.6)',
                transform: 'translateY(-2px)'
              },
              '&:active': {
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.08)'
              }
            }}>
            <span style={{ fontWeight: 500, color: '#374151' }}>{translate('sortBy')}</span>
            <span style={{ fontWeight: 600, color: '#1A5A78' }}>
              {SortByOption.find((sort) => sort.value == filters.ordering)?.label}
            </span>
            <ArrowDropDownIcon
              sx={{
                fontSize: 'calc(var(--fs-xl) * 1.132075)',
                marginLeft: 'auto',
                transition: 'transform 0.2s ease',
                transform: openSortByMenu ? 'rotate(180deg)' : 'rotate(0deg)',
                color: '#9ca3af'
              }}
            />
          </Button>
          <Popper
            sx={{
              zIndex: 9999,
              textTransform: 'capitalize'
            }}
            open={openSortByMenu}
            anchorEl={anchorRef.current}
            placement="bottom-start"
            strategy="fixed"
            role={undefined}
            transition
            disablePortal
            modifiers={[
              {
                name: 'sameWidth',
                enabled: true,
                phase: 'beforeWrite',
                requires: ['computeStyles'],
                fn: ({ state }) => {
                  state.styles.popper.width = `${state.rects.reference.width}px`;
                }
              },
              {
                name: 'preventOverflow',
                options: {
                  altBoundary: true,
                  tether: false,
                  padding: 8
                }
              },
              {
                name: 'offset',
                options: {
                  offset: [0, 4]
                }
              }
            ]}>
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                }}>
                <Paper sx={{ width: '100%' }}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList autoFocusItem>
                      {SortByOption.map((option, index) => (
                        <MenuItem
                          key={option.value}
                          selected={option.value === filters.ordering}
                          onClick={(event) => handleMenuItemClick(option.value)}
                          style={{
                            color: option.value === filters.ordering ? '#1A5A78' : '#000',
                            fontSize: 'var(--fs-md2)',
                            fontWeight: option.value === filters.ordering ? '600' : '500'
                          }}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Box>
      </Stack>
      <Table
        rowKey={(record) => record.id}
        className="custom-checkbox"
        style={{ width: '100%', padding: '20px 0' }}
        columns={orderColumns}
        dataSource={data}
        bordered={false}
        loading={{ spinning: loading, indicator: <CustomSpinner fullPage /> }}
        total={total}
        pagination={false}
        rowSelection={rowSelection}
        components={{
          header: {
            cell: ({ children, ...rest }) => {
              return (
                <th
                  {...rest}
                  style={{
                    padding: 'calc(var(--sp-md2)*1.7) !important',
                    cursor: 'default',
                    letterSpacing: '0.025em',
                    whiteSpace: 'nowrap'
                  }}>
                  {children}
                </th>
              );
            }
          }
        }}
        onRow={(record) => ({
          onClick: (e) => {
            if (!e.currentTarget.closest('th')) {
              navigate(`${ROUTER_NAME.orderDetail}/${record.id}`);
            }
          },
          style: {
            cursor: 'pointer',
            transition: 'all 0.25s ease'
          }
        })}
      />
      {!loading && paging}
      <Popper
        sx={{ zIndex: 99999 }}
        open={openPaymentFilter}
        anchorEl={paymentAnchorEl}
        placement="bottom"
        strategy="fixed"
        transition
        disablePortal
        modifiers={[
          { name: 'offset', options: { offset: [0, 8] } },
          { name: 'preventOverflow', options: { padding: 8 } }
        ]}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
            }}>
            <Paper
              sx={{
                minWidth: 'calc(var(--fs-hero)*4.24528)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
              }}>
              <ClickAwayListener
                onClickAway={() => {
                  setOpenPaymentFilter(false);
                  setPaymentAnchorEl(null);
                }}>
                <MenuList autoFocusItem>
                  {PaymentFilterOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      selected={option.value === filters.payment_method}
                      onClick={() => {
                        handlePaymentFilterSelect(option.value);
                        setOpenPaymentFilter(false);
                        setPaymentAnchorEl(null);
                      }}
                      sx={{
                        fontSize: 'var(--fs-md2)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                      }}>
                      <span style={{ flex: 1 }}>{option.label}</span>
                      {option.value === filters.payment_method && (
                        <CheckIcon sx={{ fontSize: 'var(--fs-xl)' }} />
                      )}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </PageBox>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfo: getValueFromObjectByKeys(state, ['User', 'userInfo'])
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getNotifications: () => dispatch(UserAction.getUnreadNotifCount()),
    updateNotifications: (data) => dispatch(UserAction.updateUnreadNotifCount(data))
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderPage);
